export const API_URL = process.env.NEXT_PUBLIC_API_URL

export const SEARCH_PRODUCT_URL = '/cms/index.php?route=module/isearch/ajaxget&k='
export const REVIEWS_HOMEPAGE_URL = '/back/review/get_three'
export const PRODUCTS_CATALOG_URL = '/cms/index.php?route=api/latest'

export const OC_API_URL = API_URL + process.env.NEXT_PUBLIC_OC_API_PATH
export const CDEK_WIDGET_PATH = API_URL + process.env.NEXT_PUBLIC_CDEK_WIDGET_PATH
export const IMAGE_DIR = API_URL + process.env.NEXT_PUBLIC_IMAGE_DIR

export const SITE_KEY_RECAPTCHA = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY
